import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {
  UserPositionsActionTypes,
  CreateAction,
  CreateActionFailure,
  CreateActionSuccess,
  SearchFailureAction,
  SearchSuccessAction,
  UpdateAction,
  UpdateActionFailure,
  UpdateActionSuccess, DeleteAction, DeleteActionSuccess, DeleteActionFailure,
} from './user-positions.actions';
import {map, exhaustMap, catchError} from 'rxjs/operators';
import {of} from 'rxjs/index';
import {UserPositionsModel} from '@core/models/user-positions.model';
import {Store} from '@ngrx/store';
import * as fromRoot from '@core/redux/index';
import {ApiUserPositionsService} from '@core/services/entities/user-positions/api-user-positions.service';

@Injectable()
export class UserPositionsEffects {
  constructor(private actions$: Actions,
              private store: Store<fromRoot.State>,
              private apiUserPositionsService: ApiUserPositionsService) {
  }

  @Effect()
  search$ = this.actions$.pipe(
    ofType(UserPositionsActionTypes.SearchAction),
    exhaustMap(() => {
        return this.apiUserPositionsService
          .search()
          .pipe(
            map((response) => new SearchSuccessAction(response)),
            catchError((errors) => of(new SearchFailureAction(errors)))
          );
      }
    )
  );

  @Effect()
  update$ = this.actions$.pipe(
    ofType(UserPositionsActionTypes.UpdateAction),
    map((action: UpdateAction) => action.payload),
    exhaustMap((model: UserPositionsModel) => {
        return this.apiUserPositionsService
          .update(model)
          .pipe(
            map((response) => new UpdateActionSuccess(response)),
            catchError((errors) => of(new UpdateActionFailure(errors)))
          );
      }
    )
  );

  @Effect()
  create$ = this.actions$.pipe(
    ofType(UserPositionsActionTypes.CreateAction),
    map((action: CreateAction) => action.payload),
    exhaustMap((model: UserPositionsModel) => {
        return this.apiUserPositionsService
          .create(model)
          .pipe(
            map((response) => new CreateActionSuccess(response)),
            catchError((errors) => of(new CreateActionFailure(errors)))
          );
      }
    )
  );

  @Effect()
  delete$ = this.actions$.pipe(
    ofType(UserPositionsActionTypes.DeleteAction),
    map((action: DeleteAction) => action.payload),
    exhaustMap((id: string) => {
        return this.apiUserPositionsService
          .delete(id)
          .pipe(
            map((response) => new DeleteActionSuccess(id)),
            catchError((errors) => of(new DeleteActionFailure(errors)))
          );
      }
    )
  );
}
